export default "__VITE_PUBLIC_ASSET__a9ac78a1__"